import React from "react";
import { ILiveDataListener } from "../ILiveDataListener";
import { IGOMAveragesListener } from "../IGOMAveragesListener";
import { LiveDataSet, Status } from "../API/LiveData/LiveDataSet";
import { IGOMAveragesSet, IGroupAveragesSet } from "../API/GOMAverages/GOMAveragesSet";
import { MainSite } from "../MainSite";

    type Props = {
        liveDataListeners: ILiveDataListener[];
        GOMAveragesListeners: IGOMAveragesListener[];
        timeRange: "LatestValue" | "Average3h" | "Average24h";
        children?: React.ReactNode;
    };

export const DataContext = React.createContext<LiveDataSet>(undefined);

//interface LiveDataSetValue extends GroupAveragesSet {
//    Value: any;
//    ValueMin?: any;
//    ValueMax?: any;
//    ExpiryStatus: Status;
//}

    const mapStationAveragesDataToLiveData = (
        averagesData: IGroupAveragesSet,
        timeRange: "LatestValue" | "Average3h" | "Average24h",
        //): LiveDataSetValue => {
    ): any => {

    let Value: any;
    let ValueMin: any;
    let ValueMax: any;
    let ExpiryStatus: Status;

    switch (timeRange) {

            case "LatestValue":
                Value = averagesData.LatestValue.Value;
                ExpiryStatus = averagesData.LatestValue.ExpiryStatus;
                break;
            case "Average3h":
                Value = averagesData.Average3h;
                ValueMin = averagesData.Min3h;
                ValueMax = averagesData.Max3h;
                ExpiryStatus = averagesData.Average3h == null ? Status.Expired : Status.Good;
                break;
            case "Average24h":
                Value = averagesData.Average24h;
                ValueMin = averagesData.Min24h;
                ValueMax = averagesData.Max24h;
                ExpiryStatus = averagesData.Average24h == null ? Status.Expired : Status.Good;
                break;

    }

    return {
        ...averagesData.LatestValue,
        Value,
        ValueMin,
        ValueMax,
        ExpiryStatus,
    };
    //} as LiveDataSetValue;
}

export const DataProvider = ({ liveDataListeners, GOMAveragesListeners, timeRange, children }: Props) => {

    // Purpose: Making latestData available through a React context by binding to the ILiveDataListener functionality.

    const [latestData, setLatestData] = React.useState<LiveDataSet>(MainSite.instance.liveDataManager.latestData);
    const [latestGOMAverages, setLatestGOMAverages] = React.useState<IGOMAveragesSet>(MainSite.instance.GOMAveragesManager.latestData);

    // console.log("[DataProvider] timeRange: ", timeRange)
    // console.log("[DataProvider] latestGOMAverages: ", latestGOMAverages)

    React.useEffect(() => {

        liveDataListeners.push({
            liveDataChanged: (newLatestData, ctx) => setLatestData(newLatestData)
        })

        // TODO: FIX THIS?? GOMAveragesListeners is null. But is it actually needed?
        GOMAveragesListeners.push({
            GOMAveragesChanged: (newLatestGOMAverages) => setLatestGOMAverages(newLatestGOMAverages)
        })

    }, [liveDataListeners, GOMAveragesListeners]);

    //console.log("[DataProvider] timeRange.includes('Average'): ", timeRange.includes("Average"))

    if (timeRange.includes("Average")) {

        let convertedLatestGOMAverages: LiveDataSet = {
            Stations: {},
        };

        if (latestGOMAverages) {

            // convert the format from GOMAveragesSet to LiveDataSet

            const a = Object.entries(latestGOMAverages.Stations).map(([idx, station]) => [
                station.Station.Id,
                {
                    Station: station.Station,
                    GroupValues: Object.fromEntries(
                        station.GroupAverages.map(ga => [
                            ga.ParameterGroup,
                            [mapStationAveragesDataToLiveData(ga, timeRange)]
                        ])
                    ),
                }]);

            //console.log("[DataProvider] a: ", a)

            convertedLatestGOMAverages = {
                Stations: Object.fromEntries(
                    a
                ),
            };
        }            

        // console.log("[DataProvider] convertedLatestGOMAverages: ", convertedLatestGOMAverages)

        return <DataContext.Provider value={convertedLatestGOMAverages}>{children}</DataContext.Provider>
    } else {
        // console.log("[DataProvider] latestData: ", latestData)

        return <DataContext.Provider value={latestData}>{children}</DataContext.Provider>
    }

};